var _path, _rect, _path2, _rect2, _rect3, _rect4, _rect5, _path3, _circle, _circle2, _rect6, _rect7, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCalender = function SvgCalender(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137,
    height: 95,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.17 27.645h87.557V90.6a4 4 0 0 1-4 4H4.17a4 4 0 0 1-4-4z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 87.557,
    height: 87.557,
    x: 0.17,
    y: 7.043,
    fill: "#C3C3C3",
    rx: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M.17 29.5h87.557v61.1a4 4 0 0 1-4 4H4.17a4 4 0 0 1-4-4z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.885,
    height: 7.35,
    x: 10.945,
    y: 0.6,
    fill: "#848484",
    rx: 1,
    transform: "rotate(90 10.945 .6)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12.885,
    height: 7.35,
    x: 35.398,
    y: 0.6,
    fill: "#848484",
    rx: 1,
    transform: "rotate(90 35.398 .6)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 12.885,
    height: 7.35,
    x: 59.852,
    y: 0.6,
    fill: "#848484",
    rx: 1,
    transform: "rotate(90 59.852 .6)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 12.885,
    height: 7.35,
    x: 84.303,
    y: 0.6,
    fill: "#848484",
    rx: 1,
    transform: "rotate(90 84.303 .6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    d: "M23.175 49.322V43.13h11.568v34.992h-6.912v-28.8zm20.319 21.216q4.608-3.84 7.344-6.384 2.736-2.592 4.56-5.376t1.824-5.472q0-2.448-1.152-3.84t-3.552-1.392-3.696 1.632q-1.296 1.584-1.344 4.368H40.95q.192-5.76 3.408-8.736 3.264-2.976 8.256-2.976 5.472 0 8.4 2.928 2.928 2.88 2.928 7.632 0 3.744-2.016 7.152t-4.608 5.952q-2.592 2.496-6.768 6.048h14.16v5.568H40.998V72.65z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108.271,
    cy: 66.498,
    r: 28.102,
    fill: "#848484"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.272,
    cy: 66.498,
    r: 23.882,
    fill: "#E8E8E8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.847,
    height: 17.803,
    x: 106.807,
    y: 50.328,
    fill: "#169B62",
    rx: 1.424
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2.847,
    height: 17.803,
    x: 124.609,
    y: 65.284,
    fill: "#169B62",
    rx: 1.424,
    transform: "rotate(90 124.609 65.284)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.271,
    cy: 66.498,
    r: 2.68,
    fill: "#169B62"
  })));
};
export { SvgCalender as ReactComponent };
export default __webpack_public_path__ + "images/calender.svg";